import { render, staticRenderFns } from "./gongdan_card2.vue?vue&type=template&id=23ee83ca&scoped=true&"
import script from "./gongdan_card2.vue?vue&type=script&lang=js&"
export * from "./gongdan_card2.vue?vue&type=script&lang=js&"
import style0 from "./gongdan_card2.vue?vue&type=style&index=0&id=23ee83ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee83ca",
  null
  
)

export default component.exports